
import { z } from 'zod';

//? Mapa de erros global do Zod 4 (guia do Orval §6.3): os schemas gerados não trazem mensagem, então toda mensagem
//? de validação de formulário sai daqui, em português. Mensagem própria do schema (ex.: superRefine) tem prioridade.
z.config({
    customError: (issue) => {
        switch (issue.code) {
            case 'invalid_type':
                if (issue.input === undefined || issue.input === null) return 'Campo obrigatório';
                return `Tipo inválido: esperado ${issue.expected}`;

            case 'too_small':
                if (issue.origin === 'string') {
                    if (Number(issue.minimum) <= 1) return 'Campo obrigatório';
                    return `Mínimo ${issue.minimum} caracteres`;
                }
                if (issue.origin === 'array' || issue.origin === 'set') return `Mínimo ${issue.minimum} item(s)`;
                return `Valor mínimo: ${issue.minimum}`;

            case 'too_big':
                if (issue.origin === 'string') return `Máximo ${issue.maximum} caracteres`;
                if (issue.origin === 'array' || issue.origin === 'set') return `Máximo ${issue.maximum} item(s)`;
                return `Valor máximo: ${issue.maximum}`;

            case 'invalid_format':
                if (issue.format === 'email') return 'E-mail inválido';
                if (issue.format === 'url') return 'URL inválida';
                if (issue.format === 'uuid') return 'UUID inválido';
                if (issue.format === 'date' || issue.format === 'datetime') return 'Data inválida';
                return 'Formato inválido';

            case 'invalid_value':
                return 'Selecione uma opção válida';

            default:
                return undefined;
        }
    },
});

export { z };
export { zodResolver } from '@hookform/resolvers/zod';
export { withEmptyStringsAsNull, withEmptyStringsAsUndefined } from './resolvers';

export * from './Types';
export { toast } from "react-toastify";
